var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Divider } from '@mui/material';
import { Tab } from '../../components/Tabs';
import Tooltip from '../../components/Tooltip';
import * as S from './TabMenu.css';
const TabMenu = ({ id, items = {}, 
// items are not necessary if you use 'children' prop
tabsValue, handleChange, isDividerVisible = false, variant = 'standard', children, fitToContent = false, maxContent = false, scrollButtons = 'auto', }) => {
    var _a;
    const [areScrollButtonsDisplayed, setAreScrollButtonsDisplayed] = useState(false);
    const childrenCount = !!id
        ? (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.childElementCount
        : 0;
    //if scroll buttons are displayed then childrenCount is greater than 2
    //then we want to use max-content as width value
    useEffect(() => {
        if (childrenCount && childrenCount > 2) {
            setAreScrollButtonsDisplayed(true);
        }
        else if (areScrollButtonsDisplayed) {
            setAreScrollButtonsDisplayed(false);
        }
    }, [areScrollButtonsDisplayed, childrenCount]);
    function CloneProps(props) {
        const { children } = props, other = __rest(props, ["children"]);
        return _jsx(_Fragment, { children: children(other) });
    }
    return (_jsxs(_Fragment, { children: [isDividerVisible ? _jsx(Divider, {}) : null, _jsx(S.TabsMenu, Object.assign({ id: id, value: tabsValue, indicatorColor: "primary", textColor: "primary", onChange: handleChange, scrollButtons: scrollButtons, variant: variant, "$fitToContent": fitToContent, "$maxContent": maxContent, "$areScrollButtonsDisplayed": areScrollButtonsDisplayed }, { children: children
                    ? children
                    : Object.values(items)
                        .filter(({ hidden }) => !hidden)
                        .map((item, idx) => (_jsx(CloneProps, Object.assign({ value: item.value }, { children: (tabProps) => (_jsx(Tooltip, Object.assign({ title: item.tooltip ? item.tooltip : '' }, { children: _jsx("span", { children: _createElement(Tab, Object.assign({}, tabProps, { label: item.label, key: `tab-${idx}-${item.label}`, linkTo: item.disabled ? undefined : item.linkTo, disabled: !!item.disabled, description: item.description })) }) }))) })))) }))] }));
};
export default TabMenu;
